import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/herzbuch',
    name: 'Herzbuch',
    component: () => import(/* webpackChunkName: "herzbuch" */ '../components/products/herzbuch/HeartBookContent.vue')
  },
  {
    path: '/geburtstagsbuch',
    name: 'Geburtstagsbuch',
    component: () => import(/* webpackChunkName: "geburtstagsbuch" */ '../components/products/geburtstagsbuch/BirthdayBookContent.vue')
  },
  {
    path: '/sternbuch',
    name: 'Sternbuch',
    component: () => import(/* webpackChunkName: "sternbuch" */ '../components/products/sternbuch/StarBookContent.vue')
  },
  {
    path: '/schatzbuch',
    name: 'Schatzbuch',
    component: () => import(/* webpackChunkName: "schatzbuch" */ '../components/products/schatzbuch/TreasureBookContent.vue')
  },
  {
    path: '/fotopuzzle',
    name: 'fotopuzzle',
    component: () => import(/* webpackChunkName: "fotopuzzle" */ '../components/products/fotopuzzle/CustomPuzzleContent.vue')
  },
  {
    path: '/krypt',
    name: 'krypt',
    component: () => import(/* webpackChunkName: "krypt" */ '../components/products/krypt/KryptContent.vue')
  },
  {
    path: '/paintingbynumbers',
    name: 'paintingbynumbers',
    component: () => import(/* webpackChunkName: "paintingbynumbers" */ '../components/products/malennachzahlen/PaintingByNumbersContent.vue')
  },
  {
    path: '/railway',
    name: 'railway',
    component: () => import(/* webpackChunkName: "railway" */ '../components/products/railway/RailwayContent.vue')
  },
  {
    path: '/customframepuzzle',
    name: 'framepuzzle',
    component: () => import(/* webpackChunkName: "framepuzzle" */ '../components/products/framepuzzle/FramePuzzleContent.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
